import PropTypes from 'prop-types'
import React from 'react'
import clsx from 'clsx'
import { navigate } from 'react-big-calendar/lib/utils/constants'
import FilterDropdown from './filter-dropdown'; 

class Toolbar extends React.Component {
  // Renders the toolbar UI with navigation buttons and filter dropdown
  render() {
    let {
      localizer: { messages },
      label,
      categories,
      initialFilters,
      onFilterAction
    } = this.props

    // Handles filter change action
    const handleFilterChange = (filter) => {
      onFilterAction(filter); // filter: The selected filter to apply
    };

    return (
      <div className="rbc-toolbar">
        <span className="rbc-btn-group">
          <button
            type="button"
            onClick={this.navigate.bind(null, navigate.TODAY)}
          >
            {messages.today}
          </button>
          {messages.previous && <button
            type="button"
            onClick={this.navigate.bind(null, navigate.PREVIOUS)}
          >
            {messages.previous}
          </button>}
          {!messages.previous && <button
            type="button"
            onClick={this.navigate.bind(null, navigate.PREVIOUS)}
          >
            <span className="icon-arrowdown previous">
              <ion-icon name="chevron-down-outline"></ion-icon>
            </span>
          </button>}

          {messages.next && <button
            type="button"
            onClick={this.navigate.bind(null, navigate.NEXT)}
          >
            {messages.next}
          </button>}

          {!messages.next && <button
            type="button"
            onClick={this.navigate.bind(null, navigate.NEXT)}
          >
            <span className="icon-arrowdown next">
              <ion-icon name="chevron-down-outline"></ion-icon>
            </span>
          </button>}
        </span>

        <span className="rbc-toolbar-label">{label}</span>

        <FilterDropdown categories={categories} messages={messages} initialFilters={initialFilters} handleFilterChange={handleFilterChange} />

        <span className="rbc-btn-group rbc-btn-view">{this.viewNamesGroup(messages)}</span>
      </div>
    )
  }

  // Navigates to the given action (e.g., today, next, previous)
  // action: The navigation action (navigate.TODAY, navigate.PREVIOUS, navigate.NEXT)
  navigate = (action) => {
    this.props.onNavigate(action)
  }

  // Sets the view to the specified view
  // view: The view to switch to (e.g., "week", "day", "month")
  view = (view) => {
    this.props.onView(view)
  }

  // Returns a group of buttons to switch between view names
  // messages: The localized messages for the views
  viewNamesGroup(messages) {
    let viewNames = this.props.views // viewNames: List of available views (e.g., "week", "day")
    const view = this.props.view // view: The current active view

    if (viewNames.length > 1) {
      return viewNames.map((name) => (
        <button
          type="button"
          key={name}
          data-key={name}
          className={clsx({ 'rbc-active': view === name })}
          onClick={this.view.bind(null, name)}
        >
          {messages[name]} {/* name: The name of the view, used to fetch the corresponding localized message */}
        </button>
      ))
    }
  }
}

Toolbar.propTypes = {
  view: PropTypes.string.isRequired,
  views: PropTypes.arrayOf(PropTypes.string).isRequired,
  label: PropTypes.node.isRequired,
  localizer: PropTypes.object,
  onNavigate: PropTypes.func.isRequired,
  onView: PropTypes.func.isRequired,
}

export default Toolbar
